import axios from "axios";
import { Formik } from "formik";
import { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { TailwindSpinner } from "../Spinner/Spinner";
import { toast } from "react-toastify";


export default function LoginForm({loginFn, loading}) {
  const [showPassword, setShowPassword] = useState(false);
  

return (
    <div className="w-[500px] h-[500px] bg-white rounded-lg shadow-lg flex flex-col  items-center px-2 pt-4">
      <div className="flex flex-col items-center justify-center ">
        <h1 className="text-2xl font-bold  text-myPrimary">Login</h1>
        <p className="text-grey-100 text-sm">Login to your account</p>
        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={(values) => {
            // const formData = new FormData();
            // formData.append('password', values.password);
            // formData.append('user_email', values.email);
            loginFn(
                {
                  user_email: values.email,
                  password: values.password,
                },
            {
                onSuccess: (data) => {
                  localStorage.setItem("userEmail", values.email);
                    console.log("Login successful:", data);
                },
                onError: (error) => {
                    console.error("Login failed:", error);
                },
                
            })
            console.log("Form submitted:", values);
          }}
          // onSubmit={(values) => {
          //   toast.info("System is currently under maintenance. Please try again later.", {
          //     position: "top-center",
          //     autoClose: 5000,
          //   });
          // }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = "Required";
            } else if (!/\S+@\S+\.\S+/.test(values.email)) {
              errors.email = "Invalid email address";
            }
            if (!values.password) {
              errors.password = "Required";
            } else if (values.password.length < 4) {
              errors.password = "Password must be at least 6 characters";
            }
            return errors;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit} className="w-full">
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`mt-1 block w-[300px] md:w-[402px] px-3 py-2 border h-[53px] ${
                      errors.email && touched.email
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm`}
                  />
                  <div className="absolute right-4 top-4 cursor-pointer">
                    {" "}
                    <AiOutlineMail />
                  </div>
                </div>

                {errors.email && touched.email && (
                  <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                )}
              </div>
              <div className="mb-4">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`mt-1 block w-full px-3 py-2 border h-[53px] ${
                      errors.password && touched.password
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm`}
                  />
                  <div
                    className="absolute right-4 top-4 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                  </div>
                </div>
                {errors.password && touched.password && (
                  <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                )}
              </div>
              <p className="flex justify-end mb-2 text-xs">Forgot Password?</p>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-mysecondary text-white py-2 px-4 rounded-md h-[50px] cursor-pointer flex justify-center items-center"
              >
                {loading ? <TailwindSpinner/> : "Login"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}
